export const CLUB_CMS_PATH = '/club-cms/:id';
export const EM_CLUB_CMS_PATH = '/info';



// WEBPACK FOOTER //
// ./src/components/ClubCMS/constants.js